"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenueCountryEnum = exports.VenuePriceEnum = void 0;
var VenuePriceEnum;
(function (VenuePriceEnum) {
    VenuePriceEnum["LESS_THAN_1K"] = "<\u00A31,000";
    VenuePriceEnum["BETWEEN_1_5K"] = "\u00A31,000-\u00A35,000";
    VenuePriceEnum["BETWEEN_5_10K"] = "\u00A35,000-\u00A310,000";
    VenuePriceEnum["BETWEEN_10_15K"] = "\u00A310,000-\u00A315,000";
    VenuePriceEnum["GREATER_THAN_15K"] = ">\u00A315,000";
})(VenuePriceEnum = exports.VenuePriceEnum || (exports.VenuePriceEnum = {}));
var VenueCountryEnum;
(function (VenueCountryEnum) {
    VenueCountryEnum["ENGLAND"] = "england";
    VenueCountryEnum["WALES"] = "wales";
    VenueCountryEnum["SCOTLAND"] = "scotland";
    VenueCountryEnum["IRELAND"] = "ireland";
    VenueCountryEnum["ITALY"] = "italy";
    VenueCountryEnum["GREECE"] = "greece";
    VenueCountryEnum["PORTUGAL"] = "portugal";
    VenueCountryEnum["SPAIN"] = "spain";
    VenueCountryEnum["FRANCE"] = "france";
})(VenueCountryEnum = exports.VenueCountryEnum || (exports.VenueCountryEnum = {}));
//# sourceMappingURL=venues.js.map